import api from "./axios";

export const getNotifications = (params = {}) =>
  api.get("/notifications", { params });

export const getUnreadNotificationCount = () =>
  api.get("/notifications/unread-count");

export const markNotificationRead = (notificationPublicId) =>
  api.post(`/notifications/${notificationPublicId}/read`);

export const markAllNotificationsRead = () =>
  api.post("/notifications/read-all");

export const dismissNotification = (notificationPublicId) =>
  api.post(`/notifications/${notificationPublicId}/dismiss`);
